import { UpdateMasterPostRequest } from '@/coreInfrastructureModule/axios/generated/registerBusinessManage';
import { IRegisterBusinessRepository } from '@/coreInfrastructureModule/interfaces/IRegisterBusinessRepository';
import { EditMasterItem } from '../pages/useEditBusinessStore/types';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * マスタ情報をアップデートするユースケース
 */
export class UpdateMasterUseCase {
  private repository: IRegisterBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IRegisterBusinessRepository) {
    this.repository = repository;
  }

  /**
   * マスタをアップデートする
   * @param masterType - 更新するマスタタイプ
   * @param originalInfo - 更新前情報
   * @param changedInfo - 更新後情報
   */
  public async execute(
    masterType: string,
    originalInfo: EditMasterItem,
    changedInfo: EditMasterItem
  ): Promise<INetworkResult<undefined, IError>> {
    try {
      const requestInfos: UpdateMasterPostRequest = {
        masterType,
        originalCode: originalInfo.code,
        originalName: originalInfo.name,
        changedCode: changedInfo.code,
        changedName: changedInfo.name,
      };
      const response = await this.repository.updateMaster(requestInfos);

      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました。',
          },
        },
      };
    }
  }
}
